/** Mismo listado de orígenes que en CreateEdit Cliente */
export const CUSTOMER_ORIGIN_VALUES = [
  'organic',
  'student',
  'affiliate',
  'meta_ads',
  'linkedin_ads',
  'google_ads',
  'linkedin',
  'instagram',
  'blog',
  'instagram_prospecting',
  'linkedin_prospecting',
  'cold_email',
  'cold_calling',
  'referral',
  'unknown',
] as const;
